
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produtos",
      function () {
        return require("private-next-pages/produtos/index.tsx");
      }
    ]);
  